import { jwtDecode } from 'jwt-decode';
import { useEffect, useState } from 'react';
import { CustomNotification } from '../v2-components/Notification';
import { GetLocalStorageValue } from '../_config/utils/get-local-storage-value.util';
import useNotificationStore from '../v2-pages/notification/store/useNotificationStore';

export default function useAuthCheck() {
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const clearToken = useNotificationStore((state) => state.clearToken);
	useEffect(() => {
		const user = GetLocalStorageValue('userInfo');
		if (user?.token) {
			try {
				setIsAuthenticated(true);
				const decodedToken = jwtDecode(user?.token);
				const currentTime = Date.now() / 1000;
				if (decodedToken.exp < currentTime) {
					CustomNotification({
						type: 'warning',
						message: 'El tiempo de sesión ha expirado',
						description: 'Vuelve a loguearte para acceder a tu cuenta',
					});
					setIsAuthenticated(false);
					localStorage.removeItem('userInfo');
					localStorage.removeItem('log');
					window.location.href = '/login';
					sessionStorage.removeItem('landing-storage');
					sessionStorage.removeItem('pharmacy-storage');
					sessionStorage.removeItem('search-list-storage');
					clearToken();
				}
			} catch (error) {
				console.error('Error al decodificar el token', error);
				setIsAuthenticated(false);
			}
		} else {
			console.log('no esta autenticado');
			setIsAuthenticated(false);
		}
	}, []);


	return isAuthenticated;
}